<template lang="pug">
  .conference-form-save
    v-list-item-title.mb-1(v-if="!id") Завершите создание
    v-list-item-subtitle.mb-5 Укажите даты проведения и наименование
    api-form(
      v-model="formValues"
      :fields="fields"
      :method="handleMethod"
      :inital="formInitialValues"
      :btn-props=`{
        rounded: true, btnText: saveText,
        color: 'success'
      }`
      :success-callback="successMethod"
    )
</template>

<script>

import DurationInput from '@/components/InputFields/DurationInput.vue';

export default {
  props: {
    conferenceSource: { type: Number, default: null },
    audience: { type: Object, default: null },
    lesson: { type: Object, default: null },
    date: { type: String, default: null },
    id: { type: Number, default: null },
    data: { type: Object, default: null },
    successCallback: { type: Function, default: () => {} },
  },
  data() {
    return {
      formValues: {
        date: this.date,
        ...this.data,
      },
      formInitialValues: {
        date: this.date,
        ...this.data,
      },
      fields: [
        {
          text: 'Наименование конференции',
          value: 'title',
          component: 'v-text-field',
          rules: 'required',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: 'Дата проведения',
          value: 'date',
          component: 'sdo-datetime-field',
          rules: 'required',
          component_attrs: {
            'only-date': true,
          },
        },
        {
          text: 'Продолжительность конференции',
          value: 'duration',
          rules: 'required',
          component: DurationInput,
        },
      ],
    };
  },
  computed: {
    saveText() {
      return this.id ? 'Сохранить' : 'Создать видеоконференцию в Telegram';
    },
    assigmentType() {
      if (this.audience) {
        if (this.audience.groups.length >= 1) {
          return this.$conf.CONFERENCE_TELEGRAM_TYPE.group;
        }
        if (
          this.audience.enrollments.length >= 1
        ) return this.$conf.CONFERENCE_TELEGRAM_TYPE.enrollment;
        if (
          this.audience.courses.length >= 1
        ) return this.$conf.CONFERENCE_TELEGRAM_TYPE.course;
      }
      // Webinar type
      return this.$conf.CONFERENCE_TELEGRAM_TYPE.user;
    },
    assigmentSubjects() {
      if (!this.assigmentType) return [];
      switch (this.assigmentType) {
        case (this.$conf.CONFERENCE_TELEGRAM_TYPE.course): {
          return this.audience.courses;
        }
        case (this.$conf.CONFERENCE_TELEGRAM_TYPE.enrollment): {
          return this.audience.enrollments;
        }
        case (this.$conf.CONFERENCE_TELEGRAM_TYPE.group): {
          return this.audience.groups;
        }
        default: return [];
      }
    },
  },
  watch: {
    lesson: {
      handler(val) {
        if (val) {
          this.formValues.title = this.lesson.name;
        }
      },
      immediate: true,
    },
  },
  methods: {
    successMethod(val) {
      this.$emit('on-success');
      this.successCallback(val);
    },
    handleMethod(data) {
      return this.id ? this.telegramConferenceEdit(data) : this.telegramConferenceCreate(data);
    },
    telegramConferenceCreate({ data, obs }) {
      const payloads = {
        title: data.title,
        lesson_id: this.lesson?.id,
        // date_start: `${data.date} ${data.duration.start}`,
        // date_end: `${data.date} ${data.duration.end}`,
        teacher_id: this.$user.data.teacher_id,
        is_open: this.audience.is_open,
        courses: this.audience.courses.map((i) => i.id),
        prior_records: this.audience.enrollments.map((i) => i.id),
        ...this.getDates(data),
      };
      if (this.assigmentType) {
        payloads.assignment = {
          type: this.assigmentType,
          ids: this.assigmentSubjects.map((i) => i.id),
        };
        payloads.type = this.assigmentType;
      }
      return this.$api.telegram.conferenceCreate(payloads, obs);
    },

    getDates({ date, duration }) {
      return {
        date_start: this.$dp.dateprintServer(new Date(`${date}T${duration.start}:00`)),
        date_end: this.$dp.dateprintServer(new Date(`${date}T${duration.end}:00`)),
      };
    },

    telegramConferenceEdit({ data }) {
      const payloads = {
        title: data.title,
        ...this.getDates(data),
      };
      return this.$api.telegram.conferenceUpdate(this.id, payloads);
    },
  },
};
</script>
